import { DashboardModule } from '@domain-group/suit-theme'

import BlankState from '@components/BlankState'

import useProcessChecklist from '../../hooks/useProcessChecklist'

import TaskListItem from './TaskListItem'

import NoTaskImageUrl from '../../assets/no-tasks.svg'

interface FailedTaskListItemsProps {
  processChecklistPayload: ReturnType<typeof useProcessChecklist>,
}

const FailedTaskListItems = (props: FailedTaskListItemsProps) => {
  const {
    processChecklistPayload: {
      failedTaskListItemsPayload: { filteredTaskListItems, hasFilteredTaskListItems },
      taskList: { completed },
    },
  } = props

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title={hasFilteredTaskListItems ? 'Failed Items' : 'Checklist Submission'}
    >
      {!hasFilteredTaskListItems && (
        <BlankState
          imageUrl={NoTaskImageUrl}
          subtitle="All checks have passed. Task will progress to the next step."
          title="No Failed Items"
        />
      )}

      {filteredTaskListItems.map(taskListItem => (
        <TaskListItem key={taskListItem.id} disabled={completed} taskListItem={taskListItem} />
      ))}
    </DashboardModule>
  )
}

export default FailedTaskListItems
